export const API_BASE_DEV = "https://20.39.184.63:4001"; // CORS 서버 설정 Access-Control-Allow-Origin: *
export const API_BASE_PROD = "https://sei-api.ls-electric.com"; // CORS 서버 설정 Access-Control-Allow-Origin: *
export const API_VERSION_URL = "/api/v4";
export const API_BASE = (process.env.NODE_ENV.includes("dev") ? API_BASE_DEV : API_BASE_PROD) + API_VERSION_URL;
